export interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  language: string
  lastUpdatedAvatar?: string
  memberPermissions: ReadonlyArray<Permission>
  settings: MemberSettings
  showOnboarding: boolean
  specialTerms: null | { identifier: string; accepted: boolean; acceptedAt: string }
}

export interface MemberSettings {
  onboardingCompleted: boolean
  coachOnboardingCompleted: boolean
  notifications: {
    email: EmailNotificationSettings
  }
}

export type EmailNotificationSettings = Record<string, boolean>

export enum Permission {
  // Feedback
  FEEDBACK_GIVE = 'feedback:give',
  FEEDBACK_READ_GIVEN = 'feedback:read_given',
  FEEDBACK_INITIATE = 'feedback:initiate',
  FEEDBACK_RECEIVE = 'feedback:receive',
  FEEDBACK_READ_FROM_STUDENT = 'feedback:read_from_student',
  FEEDBACK_READ_FROM_COACHEE = 'feedback:read_from_coachee',

  // Coaching
  COACHING_MANAGE_CYCLE = 'coaching:manage_cycle',
  COACHING_ASSIGN = 'coaching:assign',
  COACHING_START_SURVEY = 'coaching:start_survey',
  COACHING_CREATE_GOAL = 'coaching:create_goal',

  // Organization
  ORG_MANAGE_MEMBERS = 'org:manage_members',
  ORG_MANAGE_SETTINGS = 'org:manage_settings',
  TEAM_VIEW_MEMBERS = 'team:view_members',

  // Portal
  PORTAL_MANAGE = 'portal:manage',

  // TeachingUnit
  TEACHING_UNIT_CREATE = 'teaching_unit:create',

  // Lesson
  LESSON_START = 'lesson:start',
}
